import { Row } from "antd";
import styled from "styled-components";

const ListItemCustomLoader = (props: any) => {
  const { loading, count } = props;

  return (
    <>
      {loading ? (
        <Wrapper>
          <Row>
            {[...Array.from(Array(count).keys(), (n) => n + 1)].map((item, index): any => (
              <div key={index} className="sk-container">
                <div className="d-flex">
                  <div className="img-container">
                    <div style={{ width: "75px" }}>
                      <span className="skeleton-box preview-1"></span>
                      <span className="skeleton-box preview-2"></span>
                      <span className="skeleton-box preview-3"></span>
                      <span className="skeleton-box preview-4"></span>
                    </div>
                  </div>
                  <div className="w-50 d-block details">
                    <span
                      className="skeleton-box radius-1"
                      style={{ height: "25px", width: "50%", marginTop: "10px" }}
                    ></span>
                    <div className="clear"></div>
                    <span
                      className="skeleton-box mb-0 radius-1"
                      style={{ height: "15px", width: "30%", marginTop: "10px" }}
                    ></span>
                  </div>
                  <div className="actions">
                    <div className="inner-actions">
                      {props.isAssetWithoutCampaign ? (
                        <div className="save-campaign">
                          <div className="skeleton-box icon"></div>
                          <div className="skeleton-box text"></div>
                        </div>
                      ) : (
                        <div className="stats">
                          <div className="skeleton-box icon"></div>
                          <div className="skeleton-box icon"></div>
                          <div className="skeleton-box icon"></div>
                          <div className="skeleton-box icon"></div>
                          <div className="skeleton-box icon"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Row>
        </Wrapper>
      ) : null}
    </>
  );
};

export default ListItemCustomLoader;

const Wrapper = styled.div`
  overflow: hidden;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0px;
    margin: 5px 0;
    border-radius: 10px;
    .clear {
      clear: both;
    }
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #e9e9e9;
      &.radius-1 {
        border-radius: 10px;
      }
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }

    .img-container {
      width: 10%;
      padding: 15px;
      display: flex;
    }

    .preview-1 {
      width: 50%;
      height: 35px;
      border-radius: 6px 0px 0px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      border-right: 1px solid #fff;
    }
    .preview-2 {
      width: 50%;
      height: 35px;
      border-radius: 0px 6px 0px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
    }
    .preview-3 {
      width: 50%;
      height: 35px;
      border-radius: 0px 0px 0px 6px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-right: 1px solid #fff;
    }
    .preview-4 {
      width: 50%;
      height: 35px;
      border-radius: 0px 0px 6px 0px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
    }

    .details {
      padding: 15px 20px 10px 0px;
      background-color: #ffffff;
      width: 50%;
    }
    .save-campaign {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 45px;
      .icon {
        height: 30px;
        width: 40px;
        border-radius: 50px;
      }
      .text {
        height: 20px;
        width: 50%;
        margin-left: 20px;
        border-radius: 50px;
      }
    }
    .actions {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .inner-actions {
        width: 60%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .stats {
      width: 70%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .icon {
        height: 40px;
        width: 30px;
        border-radius: 50px;
      }
    }
  }
`;
